module.exports = __webpack_public_path__ + "media/images/icons/makeshift-logo-a403e1d1fc832decee49c09f9963828e.svg";